import { render, staticRenderFns } from "./email-tag-config.vue?vue&type=template&id=435fd7b3&scoped=true"
import script from "./email-tag-config.vue?vue&type=script&lang=js"
export * from "./email-tag-config.vue?vue&type=script&lang=js"
import style0 from "./email-tag-config.vue?vue&type=style&index=0&id=435fd7b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435fd7b3",
  null
  
)

export default component.exports